module.exports = __webpack_public_path__ + "static/img/a048.a82c561.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a048.jpg
// module id = /UWt
// module chunks = 0